import { render, staticRenderFns } from "./cost_archive.vue?vue&type=template&id=de2632b4&"
import script from "./cost_archive.vue?vue&type=script&lang=js&"
export * from "./cost_archive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports